


























































































































































































































import {WorkTaskRuleModel, AccountTypeEnum, TenantUserModel, WorkTaskStatementModel, TenantModel} from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { workTaskRulesStore } from '../+state/store';
import WorkTaskRuleDialog from '@/libs/parties/components/WorkTaskRuleDialog.vue';
import WorkTaskRuleCreateDialog from '@/libs/parties/components/WorkTaskRuleCreateDialog.vue';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { CrudOrderBy } from '@/libs/core/+state/models/crud-order-by';
import ExportDialog from "@/libs/common/components-smart/ExportDialog.vue";
import {workTaskStatementsStore} from "@/libs/work-task-statements/+state/store";
import {tenantsStore} from "@/libs/tenants/+state/store";
import { Filters, PageFilter } from '@/filters';

@Component({
    components: {
        WorkTaskRuleDialog,
        WorkTaskRuleCreateDialog
    }
})
export default class WorkTaskRules extends Page {

    pageInitialization = true;
    mobileFiltersShow = false;
    filterParty: string | null = "";
    filterTown: string | null = "";
    filterDistrict: string | null = "";
    filterState: string | null = "";
    filterUser: string | null = "";
    searchValue: string | null = "";
    pageIndex = 1;
    pageSize = 25;
    sortBy = [ "createdAt" ];
    sortDesc = [ true ];

    get headers() {
        return [
            { text: "Datum vytvoření", value: "createdAt", align: "left", width: "10%" },
            { text: this.$i18n.t("newWorkTasks.table.headers.client"), value: "party.lastName", align: "left", width: "10%" },
            { text: this.$i18n.t("newWorkTasks.table.headers.district"), value: "party.district.name", align: "left", width: "8%" },
            { text: this.$i18n.t("newWorkTasks.table.headers.town"), value: "party.town.name", align: "left", width: "8%" },
            { text: "Úkon", value: "catalogueItem.name", align: "left", width: "25%" },
            { text: this.$i18n.t("newWorkTasks.table.headers.mainCareProvider"), value: "party.mainCareProvider.lastName", align: "left", width: "7%" },
            { text: this.$i18n.t("newWorkTasks.table.headers.phoneNumber"), value: "party.phoneNumber", align: "left", width: "7%" },
            { text: this.$i18n.t("newWorkTasks.table.headers.status"), value: "workTaskState.position", align: "left", width: "5%" },
            { text: "Zahájení", value: "startDate", align: "left", width: "7%" },
            { text: "Ukončení", value: "endDate", align: "left", width: "7%" },
            { text: "Pravidelnost", value: "frequency", align: "left", width: "7%" },
            { text: "", value: "id", align: "left", width: "5%" },
        ];
    }

    get items () {
        return [...workTaskRulesStore.useGetter(CrudGetter.Data)];
    }

    get loading () {
        return workTaskRulesStore.useGetter(CrudGetter.Pending);
    }

    get totalRows (): number {
        return ({...workTaskRulesStore.useGetter(CrudGetter.DataStats)} as CrudDataStats)?.rowCount;
    }

    get isAdmin (): boolean {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        return tenantUser.accountType == AccountTypeEnum.Admin;
    }

	get exporting(): boolean {
		return workTaskRulesStore.useGetter(CrudGetter.Downloading);
	}

	get enableWorkTaskRuleCreate (): boolean {
		const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
		const tenant = tenantsStore.useGetter(CrudGetter.Detail, this.tenantId) as TenantModel;
		return tenantUser.accountType == AccountTypeEnum.Admin || tenantUser.accountType == AccountTypeEnum.Manager || (tenantUser.accountType == AccountTypeEnum.Worker && tenant.enableCreateWorkTaskRuleByWorker == true);
	}

    @Prop() tenantId!: string;

    @Ref() workTaskRuleDialog!: WorkTaskRuleDialog;
    @Ref() workTaskRuleCreateDialog!: WorkTaskRuleCreateDialog;
		@Ref() exportDialog!: ExportDialog;

    @Watch("searchValue")
    @Watch("filterParty")
    @Watch("filterTown")
    @Watch("filterDistrict")
    @Watch("filterUser")
    @Watch("filterState")
    filtersChanged (v: string, p: string) {
        this.saveQuery();
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.pageIndex = 1;
            this.loadItems();
        });
    }

    @Watch("pageIndex")
    @Watch("pageSize")
    paginationChanged () {
        this.saveQuery();
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.loadItems();
        });
    }

    @Watch("pageSize")
    pageSizeChanged () {
        this.pageIndex = 1;
    }

    @Watch("sortBy")
    @Watch("sortDesc")
    sortChanged () {
        this.saveQuery();
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.loadItems();
        });
    }

    created () {
        if (this.getQuery("party") != null || this.getQuery("district") != null || this.getQuery("town") != null || this.getQuery("user") != null || this.getQuery("state") != null || this.getQuery("pageSize") != null) {
            this.filterParty = this.getQuery("party") ?? "";
            this.filterDistrict = this.getQuery("district") ?? "";
            this.filterTown = this.getQuery("town") ?? "";
            this.filterUser = this.getQuery("user") ?? "";
            this.filterState = this.getQuery("state") ?? "";
            this.pageSize = this.getQueryInt("pageSize") ?? 25;
        }
        else {
            this.filterParty = Filters.loadFilter('WorkTaskRules', 'party') ?? null;
            this.filterDistrict = Filters.loadFilter('WorkTaskRules', 'district') ?? null;
            this.filterTown = Filters.loadFilter('WorkTaskRules', 'town') ?? null;
            this.filterUser = Filters.loadFilter('WorkTaskRules', 'user') ?? null;
            this.filterState = Filters.loadFilter('WorkTaskRules', 'state') ?? null;
            this.pageSize = Number(Filters.loadFilter('WorkTaskRules', 'pageSize', '25')) ?? 25;
            this.saveQuery();
        }
    }

    mounted () {
        this.loadItems();
    }

    saveQuery () {
        this.setQuery("party", this.filterParty);
        this.setQuery("district", this.filterDistrict);
        this.setQuery("town", this.filterTown);
        this.setQuery("user", this.filterUser);
        this.setQuery("state", this.filterState);
        this.setQuery("pageSize", this.pageSize?.toString());
        const filters: PageFilter = {
            pageName: 'WorkTaskRules',
            filters: [
                { name: 'party', value: this.filterParty },
                { name: 'district', value: this.filterDistrict },
                { name: 'town', value: this.filterTown },
                { name: 'user', value: this.filterUser },
                { name: 'state', value: this.filterState },
                { name: 'pageSize', value: this.pageSize > 0 ? this.pageSize : 25 }
            ]
        };
        Filters.saveFilters(filters);
    }

    clearFilters () {
        this.filterParty = null;
        if (this.isAdmin) {
            this.filterDistrict = null;
        }
        this.filterTown = null;
        this.filterUser = null;
        this.filterState = null;
        this.searchValue = null;
        this.saveQuery();
    }

    getFilters(): CrudQueryPredicate[] {

        let filters: CrudQueryPredicate[] = [];

        if (this.searchValue)
            filters.push({ field: "catalogueItem.name", op: "c", comparand: this.searchValue });
        
        if (this.filterParty) 
            filters.push({ field: "partyId", op: "eq", comparand: this.filterParty });
        
        if (this.filterUser) 
            filters.push({ field: "party.mainCareProviderId", op: "eq", comparand: this.filterUser });
        
        if (this.filterDistrict) 
            filters.push({ field: "party.districtId", op: "eq", comparand: this.filterDistrict });

        if (this.filterTown) 
            filters.push({ field: "party.townId", op: "eq", comparand: this.filterTown });

        if (this.filterState) 
            filters.push({ field: "workTaskStateId", op: "eq", comparand: this.filterState });
        
        return filters;

    }

    getPayload() {
        const orderBy: CrudOrderBy<WorkTaskRuleModel>[] = [];
        if (this.sortBy.length == 0) {
            orderBy.push({
                field: "createdAt",
                index: 1,
                order: "desc"
            });
        }
        else {
            orderBy.push({
                field: this.sortBy.first(),
                index: 1,
                order: this.sortDesc.first() ? "desc" : "asc"
            });
        }
        return createCrudQueryPayload<WorkTaskRuleModel>(orderBy, this.getFilters(), {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
        });
    }

    loadItems () {
        workTaskRulesStore.dispatch(CrudAction.GetAll, this.getPayload());
        this.subscribe(workTaskRulesStore, CrudReponse.GetAll).then(() => {
            this.pageInitialization = false
        });
    }

    openItemClick (v: WorkTaskRuleModel) {
        this.workTaskRuleDialog.open(v.id!, v.partyId!);
    }

    createClick () {
        this.workTaskRuleCreateDialog.open();
    }

	exportClick () {
			this.exportDialog.open();
	}

	exportDownload () {
		workTaskRulesStore.dispatch(CrudAction.Download, this.getPayload());
		this.subscribe(workTaskRulesStore, CrudReponse.Download).then(() => {
			this.exportDialog.close();
		});
	}

}
